<div class="{{options.cssClasses.messageDiv}}" (click)="close()" [ngClass]="classObj">
    {{item.message | localize: item.parameter | trimText: options.maxLength}}
</div>